export default __webpack_public_path__ + "locales/uk-UA/InviteDialog.json?hash=690391a129a4d45cc48bd4bf3dc45488";